import { useState } from "react";
import type { DiagnosticsResult } from "@ai-pos/shared";
import { diagnosticsApi } from "../api/resources.js";

export function SystemDiagnostics() {
  const [result, setResult] = useState<DiagnosticsResult | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const run = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await diagnosticsApi.get();
      setResult(res.diagnostics);
    } catch (err) {
      setError(err instanceof Error ? err.message : "診断に失敗しました");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="stack" style={{ maxWidth: 560 }}>
      <h2>システム診断</h2>
      <button className="btn btn-primary btn-lg" onClick={() => void run()} disabled={loading}>
        {loading ? "診断中..." : "診断を実行"}
      </button>
      {error && <div className="alert alert-error">{error}</div>}
      {result && (
        <div className="card stack">
          <div className="row">
            <span>データベース</span>
            <span className="spacer" />
            {result.databaseOk ? <span className="badge">正常</span> : <span className="badge badge-danger">異常</span>}
          </div>
          <div className="row">
            <span>プリンター方式</span>
            <span className="spacer" />
            <span className="badge">{result.printerProvider}</span>
          </div>
          <div className="row">
            <span>プリンター接続</span>
            <span className="spacer" />
            {result.printerReachable ? <span className="badge">正常</span> : <span className="badge badge-danger">異常</span>}
          </div>
          <div className="alert alert-warning">{result.printerMessage}</div>
          <div>サーバー時刻: {new Date(result.serverTime).toLocaleString("ja-JP")}</div>
        </div>
      )}
    </div>
  );
}
